import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

const ProfileMenuSkeleton = (): ReactNode => (
  <div className="flex flex-col gap-1 rounded-lg border border-border-card bg-bg-primary px-2 py-4">
    {Array.from({ length: 5 }, (_, index) => (
      <div key={index} className="flex h-11 items-center px-4">
        <Skeleton className="h-5 w-full rounded-sm" />
      </div>
    ))}
  </div>
)

export default ProfileMenuSkeleton
